import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { findUser, fetchConfigWhatsappData } from '../../store/actions/userAction'
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid, Switch, TextField, Button, Box } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleSharpIcon from '@mui/icons-material/CheckCircleSharp';
import ReplaySharpIcon from '@mui/icons-material/ReplaySharp';
import env from '../../env'
import Header from '../../components/Header'
import CssBaseline from '@material-ui/core/CssBaseline';
import Menubar from '../../components/Menubar';
import ScanQR from '../../components/scanQR'
const { io } = require("socket.io-client");

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  layoutMainCreateApp: {
    background: "white",
    padding: "2rem 2rem",
    borderRadius: "10px",
    [theme.breakpoints.up("sm")]: {
      width: "80%",
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  contentCreateApp : {
    paddingTop: "3%",
    paddingLeft: "15%",
    backgroundColor: "#e8e8e8",
    paddingRight: "5%",
    paddingBottom: "14%",

    [theme.breakpoints.down("sm")]: {
      paddingTop: "30%",
      paddingLeft: "0",
      paddingRight: "0"
    },
  },
}));

const BroadcastSetting = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const classes = useStyles();
    const path = useLocation();

    const [isLoading, setIsLoading] = useState(true);
    const [isScanned, setIsScanned] = useState(false);
    const [isExpired, setIsExpired] = useState(false);
    const [isScanning, setIsScanning] = useState(false);
    const [isChecking, setIsChecking] = useState(true);
    const [isQueued, setIsQueued] = useState(false);

    const [qrCode, setQrCode] = useState('');
    const [sessionMessage, setSessionMessage] = useState(null);
    const [sessionMessageError, setSessionMessageError] = useState(null);
    const [isDisabled, setIsDisabled] = useState(true)
    const [number, setNumber] = useState('Loading');
    const [status, setStatus] = useState('Waiting');

    useEffect(() => {
      socket.on("connect", data => {
        socket.emit("join", path.pathname);
      });          
    }, [])

    useEffect(() => {
      dispatch(findUser())
      dispatch(fetchConfigWhatsappData())
    }, [dispatch])
  
    const user = useSelector(state => state.userReducer.userLogin)
    const user_config = useSelector(state => state.userReducer.userConfig)
    const packageData = useSelector(state => state.userReducer.package)

    useEffect(() => {
      const hourToMs =  12 * 60 * 60000;
      if (qrCode) {
        setIsDisabled(true)
        setIsLoading(false)
        setIsScanned(false)
        setIsScanning(true)
        setNumber('Loading')
        setStatus('Waiting')  

      } else if (user_config?.wid) {
        if (new Date(Date.now() - new Date(user_config.updatedAt)) > hourToMs ) {
          if (isQueued) {
            setIsDisabled(true)
          } else {
            setIsDisabled(false)              
          }
        } else {
          setIsDisabled(true)
        }

        if (isQueued) {
          setIsLoading(true)         
        } else {
          setIsLoading(false)
        }

        setIsScanned(true)
        setIsExpired(false)
        setIsScanning(false)
        setNumber(user_config.wid)
        setStatus('Scan Sukses!')
      } else {
        setIsDisabled(true)
        setIsLoading(true)
        setIsScanned(false)
        setIsExpired(false)
        setIsScanning(false)

        if (packageData.name === 'professional') {
          setIsDisabled(false)
        } else {
          setSessionMessageError('Upgrade to professional (Whatsapp Business API Quickey) to Access this!')
          setTimeout(() => {            
            setSessionMessageError('')
          }, 60000);
        }
      }
      setTimeout(() => {            
        setIsChecking(false)
        setIsLoading(false)
      }, 3000);            
    }, [user_config, packageData, qrCode, isQueued])

    const socket = io(env.REACT_APP_BE_URL, {
      withCredentials: true,
      extraHeaders: {
        "my-custom-header": "abcd"
      }
    });

    const handleSession = () => {
      setIsLoading(true)
      setIsScanned(false)
      setIsExpired(false)

      socket.emit('create-session', {
        id: user._id,
        roomName: path.pathname
      });      
    }

    const handleSessionUpdate = (e) => {
      e.preventDefault()
      if (user_config?.wid) {
        setIsLoading(true)
        setIsScanned(false)
        setIsExpired(false)
  
        socket.emit('create-session', {
          id: user._id,
          roomName: path.pathname
        });              
      } else {
        setSessionMessageError('Click Generate QR Code First')
        setTimeout(() => {            
          setSessionMessageError('')
        }, 3000);    
      }
    }

    const handleReload = () => {
      window.location.reload();
    }

    socket.on("message", data => {
      setSessionMessage(data.text)
    });

    socket.on("message_error", data => {
      setSessionMessageError(data.text)
    });

    socket.on("qr", data => {
      setSessionMessage(data.text)
      setQrCode(data.src)
    });

    socket.on("qr_expired", data => {
      setSessionMessage(data.text)
      setIsLoading(false)
      setIsScanned(false)
      setIsExpired(true)
    });

    socket.on("server_busy", data => {
      setIsQueued(true)
      setIsDisabled(true)
      setSessionMessage(data.text)
    });

    socket.on("server_free", data => {
      setIsQueued(false)
      setSessionMessage(null)
    });

    socket.on("ready", data => {
      setSessionMessage(data.text)
      setIsQueued(false)
      dispatch(fetchConfigWhatsappData())
    });

    socket.on("authenticated", data => {
      setSessionMessage(data.text)
      setIsScanned(true)
      setQrCode(null)
      setIsChecking(false)
    });

    const handleHome = () => {
      history.push('/broadcast/template')
    }

    return (
      <React.Fragment>
      <Header page='Setting'/>
      <CssBaseline />
      <Menubar/>
      <Grid item xs={12} md={12} className={classes.contentCreateApp}>
      <Typography component="h1" variant="h4" align="center" color="textPrimary" spacing={4} gutterBottom>
          Konfigurasi
      </Typography>
        <main className={classes.layoutMainCreateApp}>
            <React.Fragment>
            <form className={classes.form}>
            <Grid container spacing={3} style={{justifyContent: "center"}}>
              <Box className="d-flex mb-15 w-100" style={{ justifyContent: 'space-between' }}>
                <div>
                  <div className="d-flex mb-15" style={{ justifyContent: 'flex-start' }}>
                    <p className="font-size-18 bold text-darkgrey mb-15">Data Sender</p>
                    <Button
                      type="submit"
                      spacing={5}
                      style={{height: "20px", width: "80px", padding: "0px 20px"}}
                      className={isChecking? "mt-5 ml-5 btn-green text-grey text-transform-unset" : "mt-5 ml-5 btn-green text-transform-unset" }
                      disabled
                    >
                      <span className='font-size-10'>
                        Checking
                      </span>
                      {
                        isChecking ?
                        <IconButton style={{marginLeft:"5px", marginRight:"0px", padding: "0px 0px"}} color="primary">
                          <CircularProgress style={{height: "12px", width: "12px"}}/>
                        </IconButton>
                        :
                        <IconButton style={{marginLeft:"5px", marginRight:"0px", padding: "0px 0px"}} color="primary">
                          <CheckCircleSharpIcon style={{height: "12px", width: "12px"}}/>
                        </IconButton>
                      }
                    </Button>
                  </div>                
                  <p className="font-size-14 reguler text-darkgrey mb-5">Nomor Telepon</p>
                  <TextField
                    variant="outlined"
                    margin="none"
                    size="small"
                    disabled
                    value={number}
                  />
                  <p className="font-size-14 reguler text-darkgrey mt-15 mb-5">Status</p>
                  <TextField
                    variant="outlined"
                    margin="none"
                    size="small"
                    disabled
                    value={status}
                  />
                  <div style={{height:'175px'}}></div>
                </div>
                  <Grid item xs={10} md={6} style={{border: "3px dashed #dadada"}}>
                    <ScanQR isLoading={isLoading} isScanned={isScanned} isExpired={isExpired} isScanning={isScanning} qrCode={qrCode} handleSession={handleSession} isDisabled={isDisabled}/>
                  </Grid>
              </Box>
              <Box className="d-flex mb-15 w-100" style={{ justifyContent: 'space-between' }}>
                <div>
                  <Button
                    className="mr-5 btn-white text-transform-unset"
                    spacing={5}
                    onClick={handleHome}
                    style={{padding: "5px 40px"}}
                  >
                    Kembali
                  </Button>
                  <Button
                    type="submit"
                    spacing={5}
                    onClick={handleSessionUpdate}
                    style={{padding: "5px 40px"}}
                    className={isDisabled? "mr-5 btn-grey text-grey text-transform-unset" : "mr-5 btn-black text-transform-unset" }
                    disabled={isDisabled}
                  >
                    Update
                  </Button>
                  <ReplaySharpIcon className="ml-5" onClick={handleReload}/>
                </div>
                <div>
                <p className="text-center font-size-14 text-darkgrey mb-5">{sessionMessage}</p>
                </div>
              </Box>
            </Grid>
            <Grid xs={12} md={12} className="mt-30 d-flex" style={{justifyContent: "center"}}>
               <p className="text-center font-size-14 text-darkgrey mb-5">{sessionMessageError}</p>
            </Grid>
            <Grid xs={12} md={12} className="mt-50 d-flex" style={{justifyContent: "flex-start"}}>
              <p className="text-center font-size-14 text-darkgrey mb-5">Catatan:</p>
            </Grid>
            <Grid xs={12} md={12} className="d-flex" style={{justifyContent: "flex-start"}}>
              <p className="text-center font-size-14 text-darkgrey mb-5">1. Tidak support beta-multiperangkat</p>
            </Grid>
            <Grid xs={12} md={12} className="d-flex" style={{justifyContent: "flex-start"}}>
              <p className="text-center font-size-14 text-darkgrey mb-5">2. Jika ingin melakukan update/scan ulang QR Code, tekan tombol update</p>
            </Grid>
            <Grid xs={12} md={12} className="d-flex" style={{justifyContent: "flex-start"}}>
              <p className="text-center font-size-14 text-darkgrey mb-5">3. Jika QR Code tidak muncul dalam 1 menit, tekan kembali tombol generate/update</p>
            </Grid>
            <Grid xs={12} md={12} className="d-flex" style={{justifyContent: "flex-start"}}>
              <p className="text-center font-size-14 text-darkgrey mb-5">4. Scan ulang dapat dilakukan dalam 1x12 jam</p>
            </Grid>
            </form>
            </React.Fragment> 
          </main>
        </Grid>
    </React.Fragment>
    )
}

export default BroadcastSetting
